module.exports = "https://coursera_assets.s3.amazonaws.com/images/f9981360ed304b477666954b42d5586f.png";